import {request} from '../utils/request';
import {GET, POST} from '../constants/API_CONSTANTS';
import {buildUrl} from '../../functionUtils/AdminBuildUrl';
import {
  API_CRUD_DISCOUNTS,
  API_FEEDBACK_STATS,
  API_GET_SURVEYS,
  API_GET_SURVEY_CONTEXT,
  API_GET_SURVEY_REPLY_DISCOUNT,
  API_GET_SURVEY_SUMMARY,
  API_SEND_SURVEY_REPLY,
  API_SET_SURVEY_CONTACT_STATUS
} from '../constants/API_ENDPOINTS';

export const getFeedbackStatsApi = async (feedbackType, startDate, endDate) => {
  return request(GET, API_FEEDBACK_STATS(feedbackType, startDate, endDate));
};
export const test = async (status, payload) => {
  return request(GET, buildUrl(API_CRUD_DISCOUNTS(status), payload));
};

// Customer Feedback page (BFF aggregator)

export const getSurveySummaryApi = (locationId) =>
  request(GET, API_GET_SURVEY_SUMMARY(locationId));

export const getSurveysApi = (locationId, params = {}) =>
  request(GET, API_GET_SURVEYS(locationId, params));

export const getSurveyContextApi = (locationId, reviewId) =>
  request(GET, API_GET_SURVEY_CONTEXT(locationId, reviewId));

export const setSurveyContactStatusApi = (locationId, reviewId, status) =>
  request(POST, API_SET_SURVEY_CONTACT_STATUS(locationId, reviewId), {
    data: {status}
  });

export const sendSurveyReplyApi = (locationId, reviewId, {subject, body}) =>
  request(POST, API_SEND_SURVEY_REPLY(locationId, reviewId), {
    data: {subject, body}
  });

export const getSurveyReplyDiscountApi = (locationId) =>
  request(GET, API_GET_SURVEY_REPLY_DISCOUNT(locationId));
